import type {
  ProductCardTone,
  ProductCardTypography,
} from '~/utils/productCardMapper'

export type ProductCardVariantName = 'control' | 'v2'

export interface ProductCardVariant {
  variant: ProductCardVariantName
  tone: ProductCardTone
  typography: ProductCardTypography
}

/**
 * The product card every page renders (KFT-4152), on the server and the
 * client alike, so SSR and hydration always agree.
 *
 * `control` brings back the previous `ProductCard` everywhere V2 is used:
 * the rollback switch, and the branch a future A/B test would build on.
 */
export const PRODUCT_CARD_VARIANT: Readonly<ProductCardVariant> = {
  variant: 'v2',
  tone: 'default',
  typography: 'standard',
}
